var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "color-selector-wrapper" },
    [
      _vm.open
        ? _c(_setup.CColorPicker, {
            staticClass: "color-picker",
            attrs: {
              mode: _vm.isCmyk ? "cmyk" : "rgb",
              "allow-reset": false,
              "show-input-menu": _vm.showMenuTypes,
              "hide-palette": !_vm.enablePalette,
              "picker-type": _setup.currentType,
            },
            on: {
              input: function ($event) {
                return _setup.onColorSelected(true)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-end mt-auto" },
                        [
                          _c(_setup.CButton, {
                            staticClass: "mr-2",
                            attrs: {
                              variant: "outline-primary",
                              size: "sm",
                              text: "CANCEL",
                            },
                            on: {
                              click: function ($event) {
                                return _setup.emit("cancel")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(_setup.CButton, {
                            attrs: {
                              variant: "primary",
                              size: "sm",
                              text: "APPLY",
                            },
                            on: {
                              click: function ($event) {
                                return _setup.onColorSelected()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              382143643
            ),
            model: {
              value: _setup.currentColor,
              callback: function ($$v) {
                _setup.currentColor = $$v
              },
              expression: "currentColor",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }